import { render } from "./Bohnen.vue?vue&type=template&id=5791a694&scoped=true"
import script from "./Bohnen.vue?vue&type=script&lang=js"
export * from "./Bohnen.vue?vue&type=script&lang=js"

import "./Bohnen.vue?vue&type=style&index=0&id=5791a694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5791a694"]])

export default __exports__